import TYPES from './types'

export const bolUpdate = payload => ({
  type: TYPES.BOL.UPDATE,
  payload,
})
